import React from 'react';
import styled from "styled-components";

const startYear = 2025;
const currentYear = new Date().getFullYear();
const registerNo = '沪ICP备2025111369号';

const FooterContainer = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  
  a.record {
    color: #000;
    display: block;
    font-size: 12px;
    line-height: 17px;
    opacity: .5;
    text-decoration: none;
  }
  
  div.copyright {
    color: #000;
    font-size: 12px;
    line-height: 17px;
    margin-top: 2px;
    opacity: .5;
  }
`

const Footer = () => {
    return (
        <FooterContainer>
            <a class="record" href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noreferrer">备案号：{registerNo}</a>
            <div class="copyright">© {startYear === currentYear ? startYear : `${startYear} - ${currentYear}`} Portal Website. All rights
                reserved.</div>
        </FooterContainer>
    );
}

export default Footer;
